import type {
  CompositionV3Filters,
  PostingsV3Filters,
  SentimentV3Filters,
  TransitionsV3Filters,
} from '@revelio/data-access';

import { type Filter, FilterType } from '../types/filters';
import { getNumericIdFromNestedId } from './get-numeric-id-from-nested-id';

type GeographyFilters =
  | Pick<CompositionV3Filters, 'region' | 'country' | 'msa' | 'state' | 'city'>
  | Pick<TransitionsV3Filters, 'region' | 'country' | 'msa' | 'state' | 'city'>
  | Pick<PostingsV3Filters, 'region' | 'country' | 'msa' | 'state' | 'city'>
  | Pick<SentimentV3Filters, 'region' | 'country' | 'msa' | 'state' | 'city'>;

export const getV3GeographyFilters = (filter: Filter): GeographyFilters => {
  if (filter.type !== FilterType.TREE) return {};

  return filter.selections.reduce<GeographyFilters>((acc, selection) => {
    const selectionId = getNumericIdFromNestedId(selection.id);

    if (selectionId === null) return acc;

    if (selection.levelId === 'region') {
      return { ...acc, region: [...(acc.region ?? []), selectionId] };
    }
    if (selection.levelId === 'country') {
      return { ...acc, country: [...(acc.country ?? []), selectionId] };
    }
    if (selection.levelId === 'msa') {
      return { ...acc, msa: [...(acc.msa ?? []), selectionId] };
    }
    if (selection.levelId === 'state') {
      return { ...acc, state: [...(acc.state ?? []), selectionId] };
    }
    if (selection.levelId === 'city') {
      return { ...acc, city: [...(acc.city ?? []), selectionId] };
    }

    return acc;
  }, {});
};
